<!--        -->
<ul class="category-menu">
    <li><a [href]="getFootballUrl()">{{'main.category.football'|translate}}</a></li>
    <li *ngFor="let category of categories">

        <a>{{category.categoryName|translate}}</a>

        <span class="material-icons-outlined mobile-arrow">
            chevron_right
            </span>

        <div class="submenu" *ngIf="category.children">
            <div class="submenu-item-holder">
                <a *ngFor="let subCategory of category.children"
                   [href]="subCategory.url"
                   class="category-card">
                    <img [src]="subCategory.icon"
                        loading="lazy"
                         [alt]="subCategory.categoryName|translate">
                    <span>{{subCategory.categoryName|translate}}</span>
                </a>
            </div>
            <a class="see-all-events"
               *ngIf="category.linkLabel"
               [href]="category.url">{{category.linkLabel|translate}}</a>
        </div>
    </li>
</ul>


<!--            Mobile Categories-->
<!-- Görünürlük SCSS'te; bkz. top-band.component.scss başındaki ngx-layout/SSR notu. -->
<div class="button-holder mobileCategoryMenuHolder">

    <button mat-button
            [matMenuTriggerFor]="mobileCategoryMenuHolder"
            (click)="categoryMenuExpanded=!categoryMenuExpanded">
        {{'shared.labels.categories'|translate}}
        <mat-icon class="chevron-icon"
                  color="primary">
            {{categoryMenuExpanded ? 'expand_less' : 'expand_more'}}
        </mat-icon>
    </button>


    <mat-menu #mobileCategoryMenuHolder="matMenu"
              (close)="categoryMenuExpanded=false">
        <ng-container *ngFor="let category of categories">
            <a mat-menu-item
               class="category-item"
               [href]="category.url"
               [matMenuTriggerFor]="sub_menu">{{ category.categoryName|translate }}</a>
            <mat-menu #sub_menu="matMenu">
                <a mat-menu-item
                   class="sub-category-item"
                   *ngFor="let subCategory of category.children"
                   [href]="subCategory.url">
                    {{ subCategory.categoryName|translate }}
                </a>
            </mat-menu>
        </ng-container>

    </mat-menu>
</div>
